import {createSlice} from "@reduxjs/toolkit";

export const vendorDetailViewSlice = createSlice({
    name: "vendorDetailViewSlice",
    initialState: {
        activeOffersListParams: {
            page: 1,
            region: null,
            count: 0
        },
        soldOffersListParams: {
            page: 1
        }
    },
    reducers: {
        setActiveOffersNextPage: (state) => {
            state.activeOffersListParams.page += 1;
        },
        setVendorActiveRegion: (state, action) => {
            state.activeOffersListParams.region = action.payload;
        },
        resetActiveOffersPage: (state) => {
            state.activeOffersListParams.page = 1;
        },
        setSoldOffersNextPage: (state) => {
            state.soldOffersListParams.page += 1;
        },
        resetSoldOffersPage: (state) => {
            state.soldOffersListParams.page = 1;
        },
        setActiveOffersCount: (state, action) => {
            state.activeOffersListParams.count = action.payload;
        }
    }
});

export const {setActiveOffersNextPage, setVendorActiveRegion, resetActiveOffersPage, setSoldOffersNextPage, resetSoldOffersPage, setActiveOffersCount} =
    vendorDetailViewSlice.actions;
import {createSlice} from "@reduxjs/toolkit";

export const vendorDetailViewSlice = createSlice({
    name: "vendorDetailViewSlice",
    initialState: {
        activeOffersListParams: {
            page: 1,
            region: null,
            count: 0
        },
        soldOffersListParams: {
            page: 1
        }
    },
    reducers: {
        setActiveOffersNextPage: (state) => {
            state.activeOffersListParams.page += 1;
        },
        setVendorActiveRegion: (state, action) => {
            state.activeOffersListParams.region = action.payload;
        },
        resetActiveOffersPage: (state) => {
            state.activeOffersListParams.page = 1;
        },
        setSoldOffersNextPage: (state) => {
            state.soldOffersListParams.page += 1;
        },
        resetSoldOffersPage: (state) => {
            state.soldOffersListParams.page = 1;
        },
        setActiveOffersCount: (state, action) => {
            state.activeOffersListParams.count = action.payload;
        }
    }
});

export const {setActiveOffersNextPage, setVendorActiveRegion, resetActiveOffersPage, setSoldOffersNextPage, resetSoldOffersPage, setActiveOffersCount} =
    vendorDetailViewSlice.actions;
